import { render, staticRenderFns } from "./ProformasSection.vue?vue&type=template&id=7dbe6257&scoped=true"
import script from "./ProformasSection.vue?vue&type=script&lang=js"
export * from "./ProformasSection.vue?vue&type=script&lang=js"
import style0 from "./ProformasSection.vue?vue&type=style&index=0&id=7dbe6257&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbe6257",
  null
  
)

export default component.exports